import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import InputField from '@/components/InputField';
import ModalContainer from '@/components/modals/ModalContainer';
import ModalHeader from '@/components/modals/ModalHeader';
import { printApiError } from '@/utils/Util';
import ApiClient from '@/lib/apiClient';
import { closeLoader, openLoader } from '@/store/actions/LoaderAction';
import { toastError } from '@/components/Toast';

const AdditionalFabricModal = ({ onClose, productId, issueLogId, onSuccess, materialType }) => {
	const [additionalFabric, setAdditionalFabric] = useState(null);
	const additionalFabricRef = useRef(null);
	const dispatch = useDispatch();

	useEffect(() => {
		if (additionalFabricRef.current) {
			additionalFabricRef.current.focus();
		}
	}, []);

	const handleAddAdditionalFabric = async () => {
		try {
			if (!additionalFabric || additionalFabric <= 0) {
				toastError('Please enter additional fabric quantity');
				return;
			}
			dispatch(openLoader());
			const params = `/${productId}/${issueLogId}?materialType=${materialType}&quantity=${additionalFabric}`;
			await ApiClient.POST('addAdditionalFabric', {}, params);
			onSuccess();
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
			setAdditionalFabric(null);
		}
	};

	return (
		<ModalContainer onCloseModal={onClose} className="sample-location-modal delete-modal">
			<div className="popup-wrapper">
				<div className="common-popup sample-location-modal delete-modal shadow-24dp">
					<ModalHeader title="Issue additional fabric" onClose={onClose} />
					<div className="common-popup-body">
						<div className="from-group mt-3">
							<InputField
								label="Additional Fabric"
								placeholder="QTY"
								type="number"
								value={additionalFabric}
								onChange={(e) => setAdditionalFabric(e.target.value)}
								ref={additionalFabricRef}
								required
							/>
						</div>
					</div>
					<div className="modal-footer">
						<div className="footer-buttons text-right">
							<button className="button gray-outline size32" onClick={() => onClose()}>
								Cancel
							</button>
							<button
								className="button size32 ml-2 red"
								onClick={() => handleAddAdditionalFabric()}
							>
								Confirm
							</button>
						</div>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AdditionalFabricModal;
